import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_89sio4o216: FaireBrandEntity = {
  token: "b_89sio4o216",
  type: "brand",
  name: "One & Only Paper",
  avatarUrl:
    "https://cdn.faire.com/fastly/64d799145a0dae13a960275a31a890722602b1ff090c4da0a276376163362dae.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/f9a2e651575b5ca9f3e55ce9a8e65a8945189e6684049ac95f59e8ac582d1bf0.png",
  logoUrl:
    "https://cdn.faire.com/fastly/64d799145a0dae13a960275a31a890722602b1ff090c4da0a276376163362dae.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f9a2e651575b5ca9f3e55ce9a8e65a8945189e6684049ac95f59e8ac582d1bf0.png",
  location: "Raleigh, NC, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 205,
  isTopShop: true,
  isInsider: true,
  description:
    "At One and Only Paper, we believe life is a party! Founded by artist Alison Hazinski, our design-forward lifestyle products are meant to elevate everyday moments. \n\nAll of our products are illustrated and designed by Alison, and we work with carefully selected production partners to bring the highest quality items possible to market. We're frequently adding new products and designs, so check back often, especially for our bestselling matchbooks and coasters. \n\n\n",
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:14:06.390Z",
    importedBy: "entity-db-cli",
  },
};
